export default __webpack_public_path__ + "images/95d8080b7c9c9ddd6d62d9c6762b64f4.png";